import React from 'react'
import { Link } from "react-router-dom"
import { motion } from "motion/react"
import { variants, useRevealInitial } from "../lib/motion"
import pImage from "../assets/NathanielAsia-Cover.png";

const Heroimg = () => {
  return (
    <div className="flex min-h-screen flex-col-reverse items-center justify-center gap-12 px-6 pt-32 pb-16 sm:px-10 md:flex-row md:gap-20 md:pt-0">
      <motion.div
        className="flex max-w-xl flex-col items-start gap-5 text-left"
        initial={useRevealInitial("hidden")}
        animate="visible"
        variants={variants.staggerContainer}
      >
        <motion.p variants={variants.fadeUp} className="font-mono text-sm text-mist-500">
          Hi, I'm Nathaniel Asia 👋
        </motion.p>
        <motion.h1 variants={variants.fadeUp} className="text-4xl font-semibold leading-tight text-mist-100 sm:text-5xl">
          I build AI solutions that scale.
        </motion.h1>
        <motion.p variants={variants.fadeUp} className="font-mono text-sm text-mist-500">
          Software Engineer @ Rubrik, shipping generative AI
        </motion.p>

        <motion.div variants={variants.fadeUp} className="mt-2 flex gap-4">
          <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
            <Link
              to="/projects"
              className="inline-block rounded-md bg-signal-500 px-6 py-3 font-mono text-sm font-medium text-ink-950"
            >
              Projects
            </Link>
          </motion.div>
          <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
            <Link
              to="/experience"
              className="inline-block rounded-md border border-ink-800 px-6 py-3 font-mono text-sm font-medium text-mist-100"
            >
              Experience
            </Link>
          </motion.div>
        </motion.div>
      </motion.div>

      <motion.div
        initial={useRevealInitial({ opacity: 0, scale: 0.94 })}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ type: "spring", stiffness: 260, damping: 30, delay: 0.15 }}
        className="h-56 w-56 shrink-0 overflow-hidden rounded-2xl border border-ink-800 shadow-[0_0_60px_-15px_rgba(124,108,246,0.35)] sm:h-72 sm:w-72"
      >
        <img className="h-full w-full object-cover object-[57%_center]" src={pImage} alt="Nathaniel Asia" />
      </motion.div>
    </div>
  )
}

export default Heroimg
